var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_vm._v(" "+_vm._s(_vm.scope)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.currentscope)+" "+_vm._s(_vm.len)+" "),_c('v-select',{attrs:{"items":_vm.scope},on:{"change":val => {
          _vm.currentscope = val;
        }}}),_c('v-btn',{on:{"click":_vm.setScope}},[_vm._v("set")]),_c('ScopeSelector')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }